import { useEffect, useState } from 'react';

const KEY = 'nfl-auction-local-manager-id-v2';

export function useLocalManagerId(): [string | null, (id: string | null) => void] {
  const [id, setId] = useState<string | null>(() => sessionStorage.getItem(KEY));
  useEffect(() => {
    if (id) sessionStorage.setItem(KEY, id);
    else sessionStorage.removeItem(KEY);
  }, [id]);
  return [id, setId];
}
